interface FilterDateRange {
    from?: string;
    to?: string;
}

interface Filters {
    invitedAt?: FilterDateRange;
    reportGeneratedAt?: FilterDateRange;
}

interface SearchUrlParams {
    query?: string;
    filters?: Filters;
    sort?: string;
    companyId?: string;
    groupId?: string;
    page?: string;
    size?: string;
}

export function buildSearchUrl({
    query,
    filters,
    sort = '_score:desc',
    companyId,
    groupId,
    page = '1',
    size = '50',
}: SearchUrlParams): string {
    const params = new URLSearchParams();

    if (query?.trim()) params.set('query', query.trim());

    if (filters?.invitedAt?.from)
        params.set('invited_from', filters.invitedAt.from);
    if (filters?.invitedAt?.to) params.set('invited_to', filters.invitedAt.to);

    if (filters?.reportGeneratedAt?.from)
        params.set('report_generated_from', filters.reportGeneratedAt.from);
    if (filters?.reportGeneratedAt?.to)
        params.set('report_generated_to', filters.reportGeneratedAt.to);

    if (sort) params.set('sort', sort);
    if (companyId) params.set('company_id', companyId);
    if (groupId) params.set('group_id', groupId);
    if (page) params.set('page', page);
    if (size) params.set('size', size);

    return `/search?${params.toString()}`;
}

export const countActiveFilters = (filters: Filters, sort: string): number => {
    let count = 0;

    if (filters.invitedAt?.from || filters.invitedAt?.to) count++;
    if (filters.reportGeneratedAt?.from || filters.reportGeneratedAt?.to)
        count++;

    const isDefaultSort = sort === '_score:desc';
    if (!isDefaultSort) count++;

    return count;
};

export const getSearchPaginationRange = (
    currentPage: number,
    totalPages: number,
    siblingCount = 1,
): (number | string)[] => {
    const pages: (number | string)[] = [];

    const startPage = Math.max(2, currentPage - siblingCount);
    const endPage = Math.min(totalPages - 1, currentPage + siblingCount);

    pages.push(1);

    if (startPage > 2) {
        pages.push('...');
    }

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    if (endPage < totalPages - 1) {
        pages.push('...');
    }
    return pages;
};
